import { useSearchParams } from "react-router-dom";
import { useState } from "react";
import axios from "axios";

export default function CancelAppointment() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("idle");
  const token = searchParams.get("token");

  const handleCancel = async () => {
    setStatus("loading");
    const clientEmail = searchParams.get("email");
    const eventId = searchParams.get("eventId");
    const clientName = searchParams.get("name");
    const appointmentDate = searchParams.get("date");
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/cancel-appointment`, {
        token,
        clientEmail,
        eventId,
        clientName,
        appointmentDate,
      });
      setStatus("success");
    } catch (error) {
      console.error("❌ Cancellation failed", error);
      setStatus("error");
    }
  };

  if (!token) return <p>Token mancante nell’URL.</p>;

  return (
    <div style={{ padding: "40px", fontFamily: "Arial", textAlign: "center" }}>
      {status === "idle" && (
        <>
          <h2>Vuoi davvero cancellare l’appuntamento?</h2>
          <button
            onClick={handleCancel}
            style={{
              marginTop: "20px",
              padding: "12px 24px",
              backgroundColor: "#e74c3c",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Conferma Cancellazione
          </button>
        </>
      )}
      {status === "success" && (
        <div style={{ marginTop: "20px", color: "green", fontWeight: "bold" }}>
          Il tuo appuntamento è stato cancellato con successo.
        </div>
      )}
      {status === "error" && (
        <div style={{ marginTop: "20px", color: "red", fontWeight: "bold" }}>
          ❌ Si è verificato un errore durante la cancellazione. Riprova più tardi.
        </div>
      )}
      {status === "loading" && <p>⏳ Attendere...</p>}
    </div>
  );
}